import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8f16308"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spaces-group" }
const _hoisted_2 = { class: "spaces-group__info" }
const _hoisted_3 = { class: "user" }
const _hoisted_4 = { class: "user__info-title" }
const _hoisted_5 = {
  key: 0,
  class: "user__info-subtitle"
}
const _hoisted_6 = { class: "spaces-group__actions" }
const _hoisted_7 = { class: "buttons" }
const _hoisted_8 = {
  key: 0,
  class: "justify-end"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "justify-end"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "justify-end"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-wrapper info-black" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-move" })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 3,
  class: "justify-end"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-add" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 4,
  class: "justify-end"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-message" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "user__photo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-group', _ctx.group)))
        }, [
          _createVNode(_component_app_lazy_image, {
            url: _ctx.photoUrl,
            key: _ctx.photoUrl
          }, null, 8, ["url"])
        ]),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.messageGroup && _ctx.messageGroup(...args))),
          class: "user__info line-clamp"
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.group.name), 1),
          (_ctx.groupType === _ctx.NETWORK_CONTACT_TYPES.IN_GROUP_REQUEST)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.partner.firstName) + " " + _toDisplayString(_ctx.partner.lastName) + " " + _toDisplayString(_ctx.$localize('group.user.wants.join')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.groupType === _ctx.NETWORK_CONTACT_TYPES.GROUP_INVITE_REQUEST)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "btn-wrapper info",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rejectRequestToGroup && _ctx.rejectRequestToGroup(...args)))
              }, _hoisted_10),
              _createElementVNode("div", {
                class: "btn-wrapper primary",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.acceptRequestToGroup && _ctx.acceptRequestToGroup(...args)))
              }, _hoisted_12)
            ]))
          : _createCommentVNode("", true),
        (_ctx.groupType === _ctx.NETWORK_CONTACT_TYPES.IN_GROUP_REQUEST)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "btn-wrapper info",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rejectUserToGroup && _ctx.rejectUserToGroup(...args)))
              }, _hoisted_15),
              _createElementVNode("div", {
                class: "btn-wrapper primary",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.acceptUserToGroup && _ctx.acceptUserToGroup(...args)))
              }, _hoisted_17)
            ]))
          : _createCommentVNode("", true),
        (_ctx.groupType === _ctx.NETWORK_CONTACT_TYPES.OUTCOMING)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
          : _createCommentVNode("", true),
        (_ctx.groupType === _ctx.NETWORK_CONTACT_TYPES.SUGGESTION)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", {
                class: "btn-wrapper primary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.requestToJoinGroup && _ctx.requestToJoinGroup(...args)))
              }, _hoisted_23)
            ]))
          : _createCommentVNode("", true),
        (_ctx.groupType === _ctx.NETWORK_CONTACT_TYPES.MY)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", {
                class: "btn-wrapper primary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.messageGroup && _ctx.messageGroup(...args)))
              }, _hoisted_26)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}